import React, { useEffect, useState, useReducer } from 'react';
import { useAuth } from '../Context';

import { Empty, Row, Col, Typography, Button, Space, Table, Form, Input, Modal, Spin, Tooltip, message, Popover, Avatar, Card, Breadcrumb, Select, Tag } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { PlusOutlined, EditOutlined, DeleteOutlined, HomeOutlined } from '@ant-design/icons';

// import { SPEED_CLASSIFICATIONS_LIST, SPEED_CLASSIFICATIONS_LIST_SUCCESS, SPEED_CLASSIFICATIONS_LIST_ERROR } from './constants';
// import { SPEED_CLASSIFICATION_DETAILS, SPEED_CLASSIFICATION_DETAILS_SUCCESS, SPEED_CLASSIFICATION_DETAILS_ERROR } from './constants';
// import { ADD_SPEED_CLASSIFICATION_DETAILS, ADD_SPEED_CLASSIFICATION_DETAILS_SUCCESS, ADD_SPEED_CLASSIFICATION_DETAILS_ERROR } from './constants';
// import { UPDATE_SPEED_CLASSIFICATION, UPDATE_SPEED_CLASSIFICATION_SUCCESS, UPDATE_SPEED_CLASSIFICATION_ERROR } from './constants';
// import { DELETE_SPEED_CLASSIFICATION, DELETE_SPEED_CLASSIFICATION_SUCCESS, DELETE_SPEED_CLASSIFICATION_ERROR } from './constants';

import englan from '../../english.json';
import germanlan from '../../german.json';
import arabiclan from '../../arabic.json';
import frenchlan from '../../french.json';
import hindilan from '../../hindi.json';
import malayalamlan from '../../malayalam.json';

import { useFormik } from 'formik';
import axios from 'axios';
import { ToolOutlined, InfoOutlined } from '@ant-design/icons';
import retrainingDataReducer from './reducer';
import { MODEL_CLASSIFICATIONS, MODEL_CLASSIFICATIONS_ERROR, MODEL_CLASSIFICATIONS_SUCCESS, NEW_CLASS_MODAL_ADD, NEW_CLASS_MODAL_ADD_ERROR, NEW_CLASS_MODAL_ADD_SUCCESS, NEW_CLASS_MODAL_DELETE, NEW_CLASS_MODAL_DELETE_ERROR, NEW_CLASS_MODAL_DELETE_SUCCESS, NEW_CLASS_MODAL_DETAILS, NEW_CLASS_MODAL_DETAILS_ERROR, NEW_CLASS_MODAL_DETAILS_SUCCESS, NEW_CLASS_MODAL_LIST, NEW_CLASS_MODAL_LIST_ERROR, NEW_CLASS_MODAL_LIST_SUCCESS, NEW_CLASS_MODAL_UPDATE, NEW_CLASS_MODAL_UPDATE_ERROR, NEW_CLASS_MODAL_UPDATE_SUCCESS, RETRAIN_MODEL_TYPE, RETRAIN_MODEL_TYPE_ERROR, RETRAIN_MODEL_TYPE_SUCCESS } from './constants';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

export default function ClassModel() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = {newModalList : [], modeltype : [], modelClassificationDate : [], newClassModalDetails : {}, loading: false, error: false };
	const [data, dispatch] = useReducer(retrainingDataReducer, initalState);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const [showAddNewClassModelModal, setShowAddNewClassModelModal] = useState(false);
	const [showEditNewClassModelModal, setShowEditNewClassModelModal] = useState(false);
	const [showDeleteNewClassModelModal, setShowDeleteNewClassModelModal] = useState(false);

	const {getPids, pidsData} = useAuth();
	const navigate = useNavigate();

	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));

	const pidsList = [];
	const modeltypelist = [];
	const modelClassficationslist=[];

	const columns = [
		{
			title: langdata.EventName ? langdata.EventName : 'Event Name',
			dataIndex: 'eventType',
			key: 'eventType',
		},
		{
			title: langdata.PidsName ? langdata.PidsName : 'Pids Name',
			dataIndex: 'pidsinfoId',
			key: 'pidsinfoId',
			render: (pidsinfoId) => (
				<Space>
					{ pidsinfoId ? 
						(pidsData && pidsData.find((pid) => pid.id == pidsinfoId).name.toUpperCase())
						: 'CENTRAL' }
				</Space>
			)
		},
		{
			title: langdata.Date ? langdata.Date : 'Date',
			dataIndex: 'updatedAt',
			key: 'updatedAt',
		},
		
	];

	{permission==='superadmin' || permission === 'admin' ? 
		columns.push(
			{
				title: langdata.UserName ? langdata.UserName : 'User Name',
				dataIndex: 'userName',
				key: 'userName',
			},
			{
				title: langdata.ModelType ? langdata.ModelType : 'Model Type',
				dataIndex: 'modeltype',
				key: 'modeltype',
			},
			{
				title: langdata.ModelClassification ? langdata.ModelClassification : 'Model Classification',
				dataIndex: 'modelclassifications',
				key: 'modelclassifications',
			},
			{
				title: langdata.Status ? langdata.Status : 'Status',
				dataIndex: 'status',
				key: 'status',
				render: (_, status) => (
					<>
						{status &&
						<Tag color={status.status=='New' ? 'blue' : status.status=='Inprogress' ? 'gold' : 
							status.status=='Insufficient Data' ? 'gold' : status.status=='Failed' ? 'red' : status.status=='Completed' ? 'green' : ''}>
							{status.status}
						</Tag>}
					</>
				),
			},
			{
				title: langdata.PrimaryModelStatus ? langdata.PrimaryModelStatus : 'Primary Model Status',
				dataIndex: 'primaryModelStatus',
				key: 'primaryModelStatus',
				render: (_, status) => (
					<>
						{status &&
						<Tag color={status.primaryModelStatus=='New' ? 'blue' : status.primaryModelStatus=='Inprogress' ? 'gold' : 
							status.primaryModelStatus=='Insufficient Data' ? 'gold' : status.primaryModelStatus=='Failed' ? 'red' : status.primaryModelStatus=='Completed' ? 'green' : ''}>
							{status.primaryModelStatus}
						</Tag>}
					</>
				),
			},
			{
				title: langdata.Remarks ? langdata.Remarks : 'Remarks',
				dataIndex: 'remarks',
				key: 'remarks',
				render: (text) => (
					text != '-' ?
						<Popover title={langdata && langdata.Remarks ? langdata.Remarks :'Remarks'} content={text} trigger="hover">
							<Typography.Paragraph
								ellipsis={
									{
										rows: 2,
										expandable: false,
										symbol: ''
									}
								}
							>
								{text}
							</Typography.Paragraph>
						</Popover>
						: 
						<Typography>{text}</Typography>
				)
			},			
			{
				title: langdata.PrimaryModelRemarks ? langdata.PrimaryModelRemarks : 'Primary Model Remarks',
				dataIndex: 'primaryModelRemarks',
				key: 'primaryModelRemarks',
				render: (text) => (
					text != '-' ?
						<Popover title={langdata && langdata.PrimaryModelRemarks ? langdata.PrimaryModelRemarks :'Primary Model Remarks'} content={text} trigger="hover">
							<Typography.Paragraph
								ellipsis={
									{
										rows: 2,
										expandable: false,
										symbol: ''
									}
								}
							>
								{text}
							</Typography.Paragraph>
						</Popover>
						: 
						<Typography>{text}</Typography>
				)
			},			
			{
				title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
				key: 'action',
				render: (data, record) => (					
					<Space size="middle">
						<a disabled = {record.status == 'New' && record.primaryModelStatus == 'New' ? false : true} title={langdata.EditClassModel ? langdata.EditClassModel : 'Edit Class Model'} onClick={record.status == 'New' && record.primaryModelStatus == 'New' ? openEditNewClassModelModal : null}><EditOutlined/></a>
						<a disabled = {record.status == 'New'&& record.primaryModelStatus == 'New' ? false : true} title={langdata.DeleteClassModel ? langdata.DeleteClassModel : 'Delete Class Model'} onClick={record.status == 'New' && record.primaryModelStatus == 'New' ? openDeleteNewClassModelModal : null}><DeleteOutlined /></a>
					</Space>
				)
			}
		)
		:
		columns.push(
			{
				title: langdata.Status ? langdata.Status : 'Status',
				dataIndex: 'status',
				key: 'status',
				render: (_, status) => (
					<>
						{status &&
						<Tag color={status.status=='New' ? 'blue' : status.status=='Inprogress' ? 'gold' : 
							status.status=='Insufficient Data' ? 'gold' : status.status=='Failed' ? 'red' : status.status=='Completed' ? 'green' : ''}>
							{status.status}
						</Tag>}
					</>
				),
			},
			{
				title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
				key: 'action',
				render: (data, record) => (
					<Space size="middle">
						<a disabled = {record.status == 'New' && record.primaryModelStatus == 'New' ? false : true} title={langdata.EditClassModel ? langdata.EditClassModel : 'Edit Class Model'} onClick={record.status == 'New' && record.primaryModelStatus == 'New'? openEditNewClassModelModal : null}><EditOutlined/></a>
						<a disabled = {record.status == 'New' && record.primaryModelStatus == 'New' ? false : true} title={langdata.DeleteClassModel ? langdata.DeleteClassModel : 'Delete Class Model'} onClick={record.status == 'New' && record.primaryModelStatus == 'New'? openDeleteNewClassModelModal : null}><DeleteOutlined /></a>
					</Space>
				)
			}
		);
	}

	

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		dispatch( { type: NEW_CLASS_MODAL_LIST });
		getPids(authtoken);
		loadNewClassModel();
		getModelType();
		getModelClassification();
	}, []);

	pidsList.push(
		{
			value : 0,
			label : 'CENTRAL'
		}),

	pidsData && pidsData.map((item) => {
		pidsList.push({
			value : item.id,
			label : item.name.toUpperCase(),
		});
	});

	pidsList.sort((a,b) => { return a.label - b.label; });

	data.modeltype && data.modeltype.map((type)=>{
		modeltypelist.push({value:type.id, label:type.name});
	});

	data.modelClassificationDate && data.modelClassificationDate.map((type)=>{
		modelClassficationslist.push({value:type.id, label:type.alias ? type.alias : type.modelLevel});
	});

	const getModelType = () => {
	
		dispatch({ type : RETRAIN_MODEL_TYPE});
	
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/modeltype`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : data
		};
		
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({ type : RETRAIN_MODEL_TYPE_SUCCESS, payload : response.data.data});
				}else {
					dispatch({ type : RETRAIN_MODEL_TYPE_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : RETRAIN_MODEL_TYPE_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});
	
	};
	
	const getModelClassification = () => {
	
		dispatch({ type : MODEL_CLASSIFICATIONS});
	
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/modelclassifications`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : data
		};
		
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({ type : MODEL_CLASSIFICATIONS_SUCCESS, payload : response.data});
				}else {
					dispatch({ type : MODEL_CLASSIFICATIONS_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : MODEL_CLASSIFICATIONS_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});
	
	};

	const openAddNewClassModelModal = () => {
		setShowAddNewClassModelModal(true);
	};

	const cloaseAddNewClassModelModal = () => {
		setShowAddNewClassModelModal(false);
	};

	const openEditNewClassModelModal = () => {
		setShowEditNewClassModelModal(true);
	};

	const closeEditNewClassModelModal = () => {
		setShowEditNewClassModelModal(false);
	};

	const openDeleteNewClassModelModal = () => {
		setShowDeleteNewClassModelModal(true);
	};

	const deleteNewClassModel = () => {
		// const id = data.newClassModalDetails.id;
		const eventTypeId = data.newClassModalDetails.eventTypeId;
    
		dispatch({ type: NEW_CLASS_MODAL_DELETE });

		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/allevents/${eventTypeId}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};

		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) { 

					// let config2 = {
					// 	method: 'delete',
					// 	maxBodyLength: Infinity,
					// 	url: `${api}/newmodelclass/${id}`,
					// 	timeout: timeout,
					// 	headers: {
					// 		accept: 'application/json',
					// 		'Content-Type': 'application/json',
					// 		Authorization:`Bearer ${authtoken}`
					// 	}
					// };

					// axios
					// 	.request(config2)
					// 	.then((response) => {
					// 		if (response.status === 200) {
					dispatch({type: NEW_CLASS_MODAL_DELETE_SUCCESS, payload: response});
					setShowDeleteNewClassModelModal(false);   
					Modal.success({ title: langdata.Classmodelsuccessfullydeleted ? langdata.Classmodelsuccessfullydeleted : 'Class model successfully deleted.' });
					loadNewClassModel();       
					// 	} else {
					// 		dispatch({type:NEW_CLASS_MODAL_DELETE_ERROR});
					// 		Modal.warning({ title: langdata.Unabletodeletetheclassmodel ? langdata.Unabletodeletetheclassmodel : 'Unable to delete the class model.' });  
					// 	}
					// })
					// .catch((error) => {
					// 	dispatch({type:NEW_CLASS_MODAL_DELETE_ERROR});
					// 	if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					// 		message.config({
					// 			duration : 5,
					// 			maxCount : 1,
					// 		});
					// 		message.open({
					// 			type: 'error',
					// 			content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					// 		});
					// 	}
					// });

				} else {
					dispatch({type:NEW_CLASS_MODAL_DELETE_ERROR});  
					Modal.warning({ title: langdata.Unabletodeletetheclassmodel ? langdata.Unabletodeletetheclassmodel : 'Unable to delete the class model.' });  

				}
			})
			.catch((error) => {
				dispatch({type:NEW_CLASS_MODAL_DELETE_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});

	};

	const closeDeleteNewClassModelModal = () => {
		setShowDeleteNewClassModelModal(false);
	};

	const loadNewClassModel = () => {
		
		let params = '';
		if(permission !=='superadmin' && permission !== 'admin'){
			params += `userId=${parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_USER_ID`))}`;
		}
		
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/newmodelclass?${params}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
  
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type:NEW_CLASS_MODAL_LIST_SUCCESS, payload: response.data});
				}
			})
			.catch((error) => {
				dispatch({type:NEW_CLASS_MODAL_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const loadNewClassModelDetails = ((id) => {
		let details = null;

		if (data && data.newModelList) {
			data.newModelList && data.newModelList.map((item) => {
				if (item.id === id) {
					details = item;
				}

				return true;
			});
      
			dispatch( { type: NEW_CLASS_MODAL_DETAILS });
    
			if (!details) {
				dispatch({ type: NEW_CLASS_MODAL_DETAILS_ERROR });
			} else {
				dispatch({ type: NEW_CLASS_MODAL_DETAILS_SUCCESS, payload: details });

			}
		} else {
			dispatch({ type: NEW_CLASS_MODAL_DETAILS_ERROR }); 
		}
	});

	const addNewClassModalFormik = useFormik({
		initialValues: {
			addNewClassModelEventName: '',
			pidsinfoId : null,
			modelType : null,
			modelClassfications : null
		},
		onSubmit: (values) => {
			
			const eventName = values.addNewClassModelEventName ? values.addNewClassModelEventName : '';
			const pidsinfoId = values.pidsinfoId || values.pidsinfoId == 0 ? values.pidsinfoId : null;
			const modelType = values.modelType ? values.modelType : null;
			const modelClassfications = values.modelClassfications ? values.modelClassfications : null;
			
			if (!eventName || eventName == null || eventName === '' || pidsinfoId == null || pidsinfoId < 0) {
				Modal.warning({ title: langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields' });
				return false;
			}


			let config = {				
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/allevents`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					'eventType': eventName,								
				}
			};

			dispatch( { type: NEW_CLASS_MODAL_ADD });
      
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {

						let config2 = {
							method: 'post',
							maxBodyLength: Infinity,
							url: `${api}/newmodelclass`,
							timeout: timeout,
							headers: {
								accept: 'application/json',
								'Content-Type': 'application/json',
								Authorization:`Bearer ${authtoken}`
							},
							data: {
								'eventType': eventName,
								'modeltypeId': modelType,
								'modelclassificationsId': modelClassfications,
								'pidsinfoId': pidsinfoId == 0 ? null : pidsinfoId,
								'status':'New',
								'eventTypeId' : response.data.id,
								'userId' : parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_USER_ID`)),
								'primaryModelStatus': 'New',
							}
						};
						axios
							.request(config2)
							.then((response) => {
								if (response.status === 200 || response.status === 201) {
									Modal.success({ title: langdata.Newclassmodelsavedsuccessfully ? langdata.Newclassmodelsavedsuccessfully : 'New class model saved successfully.' });
									setShowAddNewClassModelModal(false);
									addNewClassModalFormik.resetForm();
									loadNewClassModel();
								}else {
									Modal.warning({ title: langdata.Unabletosavethenewclassmodelclassification ? langdata.Unabletosavethenewclassmodelclassification : 'Unable to save the new class model classification.' });  
								}
							}); 
			
						dispatch({type: NEW_CLASS_MODAL_ADD_SUCCESS, payload: response});
						
					} else {
						dispatch({type: NEW_CLASS_MODAL_ADD_ERROR});
						Modal.warning({ title: langdata.Unabletosavethenewclassmodelclassification ? langdata.Unabletosavethenewclassmodelclassification : 'Unable to save the new class model classification.' });  
					}
				})
				.catch((error) => {
					dispatch({type: NEW_CLASS_MODAL_ADD_SUCCESS});
					console.log('error', error.response.status);
					if(error.response.status === 400 ){
						Modal.error({ title: langdata.Eventnamealreadyexists ? langdata.Eventnamealreadyexists : 'Event name already exists.' });  
					}
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});

	const updateNewClassModalFormik = useFormik({
		enableReinitialize: true,
		initialValues: {
			updateNewClassModelEventName: data.newClassModalDetails ? data?.newClassModalDetails?.eventType : '',
			pidsinfoId : data.newClassModalDetails ? data?.newClassModalDetails?.pidsinfoId == null ? 0 : data?.newClassModalDetails?.pidsinfoId : '',
			modelType : data.newClassModalDetails ? data?.newClassModalDetails?.modeltypeId : '',
			modelClassfications : data.newClassModalDetails ? data?.newClassModalDetails?.modelclassificationsId : ''
		},
		onSubmit: (values) => {

			const id = data.newClassModalDetails.id;
			const eventTypeId = data.newClassModalDetails.eventTypeId;

			const eventName = values.updateNewClassModelEventName ? values.updateNewClassModelEventName : '';
			const pidsinfoId = values.pidsinfoId || values.pidsinfoId == 0 ? values.pidsinfoId : null;
			const modelType = values.modelType ? values.modelType : null;
			const modelClassfications = values.modelClassfications ? values.modelClassfications : null;


			if (!eventName || eventName == null || eventName === '' || pidsinfoId == null || pidsinfoId < 0) {
				Modal.warning({ title: langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields' });
				return false;
			}

			if(data?.newClassModalDetails?.eventType !== eventName) {
				let config = {
					method: 'patch',
					maxBodyLength: Infinity,
					url: `${api}/allevents/${eventTypeId}`,
					timeout: timeout,
					headers: {
						accept: 'application/json',
						'Content-Type': 'application/json',
						Authorization:`Bearer ${authtoken}`
					},
					data: {
						'eventType': eventName,
					}
				};

				dispatch( { type: NEW_CLASS_MODAL_UPDATE });

				axios
					.request(config)
					.then((response) => {
						if (response.status === 200 || response.status === 201) {
							dispatch({type: NEW_CLASS_MODAL_UPDATE_SUCCESS, payload:response});
							// Modal.success({ title: langdata.Classmodelupdatedsuccessfully ? langdata.Classmodelupdatedsuccessfully : 'Class model updated successfully.'});
							setShowEditNewClassModelModal(false);
							// loadNewClassModel();
						} else {
							dispatch({type: NEW_CLASS_MODAL_UPDATE_ERROR});
							// Modal.warning({ title: langdata.Unabletoupdatetheclassmodel ? langdata.Unabletoupdatetheclassmodel : 'Unable to update the class model.'});  
						}
					})
					.catch((error) => {
						dispatch({type: NEW_CLASS_MODAL_UPDATE_ERROR});
						if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
							message.config({
								duration : 5,
								maxCount : 1,
							});
							message.open({
								type: 'error',
								content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
							});
						}
					});
			}


			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/newmodelclass/${id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					'eventType': eventName,
					'modeltypeId': modelType,
					'modelclassificationsId': modelClassfications,
					'pidsinfoId': pidsinfoId == 0 ? null :  pidsinfoId,
				}
			};

			dispatch( { type: NEW_CLASS_MODAL_UPDATE });

			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: NEW_CLASS_MODAL_UPDATE_SUCCESS, payload:response});
						Modal.success({ title: langdata.Classmodelupdatedsuccessfully ? langdata.Classmodelupdatedsuccessfully : 'Class model updated successfully.'});
						setShowEditNewClassModelModal(false);
						updateNewClassModalFormik.resetForm();
						loadNewClassModel();
					} else {
						dispatch({type: NEW_CLASS_MODAL_UPDATE_ERROR});
						Modal.warning({ title: langdata.Unabletoupdatetheclassmodel ? langdata.Unabletoupdatetheclassmodel : 'Unable to update the class model.'});  
					}
				})
				.catch((error) => {
					dispatch({type: NEW_CLASS_MODAL_UPDATE_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{ langdata && langdata.NewClassModelContent1 ? langdata.NewClassModelContent1 :  'This section is used to add a new class to the model. Once sufficient data has been collected, the model will be trained on this new class. The trained model will then be able to predict new events related to it.'}</p>
			< br/>
			<p>{ langdata && langdata.NewClassModelContent2 ? langdata.NewClassModelContent2 :  'For any undefined model levels or classes, appropriate models will be automatically picked and trained.'}</p>

		</Card>
	);

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());	
	
	
	return (

		<>
			<Content>
				<Row 
					style={{
						// marginLeft:'15px',
						// marginTop: '10px'
						margin : '10px'
					}}            
				>
					<Breadcrumb
						items={[
							{
								href: '/dashboard',
								title: <HomeOutlined />,
							},
							{
								title:  <a onClick={()=>{navigate(-1);}}>{langdata.ModelConfiguration ? langdata.ModelConfiguration : 'Model Configuration'}</a> 
							},
							{
								title: langdata.ClassModel ? langdata.ClassModel : 'Class Model',
							},
						]}
					/>
				</Row>
				<Row style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center',
				}}
				>

					<Col span={12}>
						<Row>
							<Space>
								<ToolOutlined style={{fontSize:'30px'}}/>
								{/* </Col> */}
							</Space>
							<Space>&nbsp;&nbsp;</Space>
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata.ClassModel ? langdata.ClassModel : 'Class Model'}</Title>
						</Row>
					</Col>
                    
					<Col span={12}>
						<Row justify="end">
							<Col>
								<Tooltip placement="bottom" title={langdata && langdata.Add ? langdata.Add : 'Add'}>
									<Space>
										<Button type="primary" onClick={openAddNewClassModelModal} style={{margin:'5px'}} ><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New' }</Button>
									</Space>
								</Tooltip>
								<Space>&nbsp;&nbsp;</Space>
								<Space>
									<Typography>
										<Popover title={langdata.ClassModel ? langdata.ClassModel : 'Class Model' }  content={infoContent} trigger="click">
											<Avatar size="small"><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						{ data && data?.newModelList?.length > 0 ? (
							<Table
								scroll={{
									x: 900,
								}} 
								columns={columns} 
								dataSource={data && data.newModelList} 
								onRow = {(record) => {
									return {
										onClick: () => { 
											loadNewClassModelDetails(record.id);
										}
									};
								}} />
						)
							:
							(
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
							)}
					</Col>
				</Row>
			</Content>

			<Spin fullscreen spinning={data.loading} />
      
			{/* Add Speed Classification Starts */}
			<Modal
				title={langdata.AddNewClassModel ? langdata.AddNewClassModel : 'Add New Class Model' }
				centered
				destroyOnClose={true}
				maskClosable={false}
				open={showAddNewClassModelModal}
				onOk={{cloaseAddNewClassModelModal}}
				onCancel={cloaseAddNewClassModelModal}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={cloaseAddNewClassModelModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
						<Button type="primary" onClick={addNewClassModalFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button>
					</Space>
				]}
				width={800}
			>
				<Form layout="vertical" onSubmit={addNewClassModalFormik.handleSubmit}>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="name" label={langdata.EventName ? langdata.EventName : 'Event Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenteractivityname ? langdata.Pleaseenteractivityname : 'Please enter activity name' }]} >
								<Input 
									name="addNewClassModelEventName" 
									onChange={addNewClassModalFormik.handleChange} 
									placeholder={langdata.Pleaseentereventname ? langdata.Pleaseentereventname : 'Please enter event name'} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item  label={langdata && langdata.PIDSName ? langdata.PIDSName:'PIDS Name'}  name="PIDS" rules={[{ required: true }]} >
								<Select
									name="pidsinfoId" 
									showSearch
									placeholder={langdata && langdata.SelectPIDSname ? langdata.SelectPIDSname:'Select PIDS name'}
									optionFilterProp="children"
									options={pidsList}
									onChange={(value) => addNewClassModalFormik.setFieldValue('pidsinfoId', value)}
									filterOption={filterOption}
								/>
							</Form.Item>
						</Col>
					</Row>
					{permission==='superadmin' || permission === 'admin' ?
						<>
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item label={langdata && langdata.ModelType ? langdata.ModelType:'Model Type'} name="Model Type" >
										<Select
											name="modelType" 
											showSearch
											placeholder={langdata && langdata.Selectmodeltype ? langdata.Selectmodeltype:'Select model type'}
											optionFilterProp="children"
											options={modeltypelist}
											onChange={(value) => addNewClassModalFormik.setFieldValue('modelType', value)}
											filterOption={filterOption}
										/>
									</Form.Item>
								</Col>
							</Row>	
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item label={langdata && langdata.ModelLevel ? langdata.ModelLevel:'Model Level'} name="Model Level" >
										<Select
											name="modelClassfications" 
											showSearch
											optionFilterProp="children"
											placeholder={langdata && langdata.Pleasespecifythemodelclassification ? langdata.Pleasespecifythemodelclassification:'Please specify the model classification'}
											onChange={(value) => addNewClassModalFormik.setFieldValue('modelClassfications', value)}
											value={addNewClassModalFormik.values.modelClassfications}
											filterOption={filterOption}
											options={modelClassficationslist}
										/>
									</Form.Item>						
								</Col>
							</Row>
						</>
						: null }			
				</Form>
			</Modal>
			{/* Add Speed Classification Ends */}

			{/* Edit Speed Classification Starts */}
			<Modal
                
				title={langdata.EditClassModel ? langdata.EditClassModel : 'Edit Class Model'}
				centered
				open={showEditNewClassModelModal}
				onOk={{closeEditNewClassModelModal}}
				onCancel={closeEditNewClassModelModal}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={closeEditNewClassModelModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
						{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={updateNewClassModalFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
					</Space>
				]}
				width={800}
			>
				<Form layout="vertical" onSubmit={updateNewClassModalFormik.handleSubmit}>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata.EventName ? langdata.EventName : 'Event Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenteractivityname ? langdata.Pleaseenteractivityname : 'Please enter activity name' }]} required>
								<Input 
									name="updateNewClassModelEventName" 
									onChange={updateNewClassModalFormik.handleChange} 
									placeholder={langdata.Pleaseentereventname ? langdata.Pleaseentereventname : 'Please enter event name'} 
									value={updateNewClassModalFormik.values.updateNewClassModelEventName} />
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item  label={langdata && langdata.PIDSName ? langdata.PIDSName:'PIDS Name'} required >
								<Select
									name="pidsinfoId" 
									showSearch
									placeholder={langdata && langdata.SelectPIDSname ? langdata.SelectPIDSname:'Select PIDS name'}
									optionFilterProp="children"
									options={pidsList}
									onChange={(value) => updateNewClassModalFormik.setFieldValue('pidsinfoId', value)}
									filterOption={filterOption}
									value={updateNewClassModalFormik.values.pidsinfoId || updateNewClassModalFormik.values.pidsinfoId == 0 ? updateNewClassModalFormik.values.pidsinfoId : data?.newClassModalDetails?.pidsinfoId == null ? 0 : data?.newClassModalDetails?.pidsinfoId }
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.ModelType ? langdata.ModelType:'Model Type'}  >
								<Select
									name="modelType" 
									showSearch
									placeholder={langdata && langdata.Selectmodeltype ? langdata.Selectmodeltype:'Select model type'}
									optionFilterProp="children"
									options={modeltypelist}
									onChange={(value) => updateNewClassModalFormik.setFieldValue('modelType', value)}
									filterOption={filterOption}
									value={updateNewClassModalFormik.values.modelType ? updateNewClassModalFormik.values.modelType : data?.newClassModalDetails?.modeltypeId}

								/>
							</Form.Item>
						</Col>
					</Row>	
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.ModelLevel ? langdata.ModelLevel:'Model Level'}  >
								<Select
									name="modelClassfications" 
									showSearch
									optionFilterProp="children"
									placeholder={langdata && langdata.Pleasespecifythemodelclassification ? langdata.Pleasespecifythemodelclassification:'Please specify the model classification'}
									onChange={(value) => updateNewClassModalFormik.setFieldValue('modelClassfications', value)}
									value={updateNewClassModalFormik.values.modelClassfications ? updateNewClassModalFormik.values.modelClassfications : data?.newClassModalDetails?.modelclassificationsId}
									filterOption={filterOption}
									options={modelClassficationslist}
								/>
							</Form.Item>						
						</Col>
					</Row>				
				</Form>
			</Modal>
			{/* Edit Speed Classification Ends */}

			{/* Delete Speed Classification Starts */}
			<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteNewClassModelModal} onOk={deleteNewClassModel} onCancel={closeDeleteNewClassModelModal}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}> {langdata.Areyousureyouwanttodeletethisclassmodel ? langdata.Areyousureyouwanttodeletethisclassmodel : 'Are you sure you want to delete this class model?'}</Col>
				</Row>
			</Modal>
			{/* Delete Speed Classification Ends */}
		</> 
	);
}